// Generated by genversion.
export const version = '0.39.4';
